import {Component, OnDestroy, OnInit} from '@angular/core';
import {PrimeNGConfig} from 'primeng/api';
import {environment} from '@env/environment';
import {Logger} from '@app/logger.service';
import {devTools} from '@ngneat/elf-devtools';
import {LoaderService} from '@shared/services/loader.service';
import {delay} from 'rxjs/operators';
import {CourseService} from '@app/@core/services/course.service';
import {TicketService} from '@app/@core/services/ticket.service';
import {CredentialsService} from '@app/auth/credentials.service';
import {LeisureShopRepository} from "@app/@core/repositories/leisure-shop.repository";
import {PackageInfoService} from "@app/@core/services/package-info.service";
import {LeisureShopService} from "@app/@core/services/leisure-shop.service";

const log = new Logger('App');

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    menuMode = 'static';

    lightMenu = false;

    inputStyle = 'outlined';

    ripple: boolean;

    showLoader = false;

    constructor(private primengConfig: PrimeNGConfig,
                private loaderService: LoaderService,
                private credentialsService: CredentialsService,
                private ticketService: TicketService,
                private packageInfoService: PackageInfoService,
                private leisureShopService: LeisureShopService,
                private courseService: CourseService) {
    }

    ngOnInit() {
        if (environment.production) {
            Logger.enableProductionMode();
            this.courseService.fetchAllName().subscribe({
                error: () => {
                    this.credentialsService.logout();
                }
            });
            this.leisureShopService.fetchAllName().subscribe({
                error: () => {
                    this.credentialsService.logout();
                }
            });
            this.packageInfoService.fetchAllName().subscribe({
                error: () => {
                    this.credentialsService.logout();
                }
            })

        } else {
            devTools();
            if (!this.courseService.hasLoaded()) {
                this.courseService.fetchAllName().subscribe({
                    error: () => {
                        this.credentialsService.logout();
                    }
                });
            }

            if (!this.leisureShopService.hasLoaded()) {
                this.leisureShopService.fetchAllName().subscribe({
                    error: () => {
                        this.credentialsService.logout();
                    }
                });
            }

            if (!this.packageInfoService.hasLoaded()) {
                this.packageInfoService.fetchAllName().subscribe({
                    error: () => {
                        this.credentialsService.logout();
                    }
                });
            }
        }

        log.debug('init');
        this.primengConfig.ripple = true;
        this.ripple = true;

        this.loaderService.status$.pipe(delay(0)).subscribe(show => this.showLoader = show);
    }

    ngOnDestroy(): void {
        throw new Error('Method not implemented.');
    }
}
